import React from 'react'
import './style.scss'

const Footer = () => (
  <footer className="footer">
    © {new Date().getFullYear()} M&amp;T Bank. Member FDIC. All rights
    reserved.​
    <a
      href="https://www3.mtb.com/homepage/explore-the-m-and-t-bank-help-center/bank-policies/privacy-policy"
      className="footer__link"
    >
      Privacy
    </a>
    <a
      href="https://www3.mtb.com/homepage/explore-the-m-and-t-bank-help-center/bank-policies/terms-of-use-policy"
      className="footer__link"
    >
      Terms of Use
    </a>
  </footer>
)

export default Footer
